import { Chip } from '@mui/material';
import { Datagrid, TextField, NumberField, FunctionField, DateField, List } from 'react-admin';
import { DataProviderResource } from 'src/constants';
import { getOrderStatusTagColor } from 'src/utils/colors.utils';

import { Order } from '../../models/order.model';

export interface AccountOrderListProps {
  accountId: number;
}

export const AccountOrderList = ({ accountId }: AccountOrderListProps) => {
  return (
    <List
      actions={false}
      exporter={false}
      disableSyncWithLocation
      resource={DataProviderResource.Orders}
      title=' '
      empty={false}
      queryOptions={{ meta: { accountId, skipSort: true } }}
      sort={{ field: 'createdAt', order: 'DESC' }}>
      <Datagrid isRowSelectable={() => false} bulkActionButtons={false}>
        <FunctionField
          label='Status'
          render={(record: Order) => {
            return <Chip label={record.status.label} sx={getOrderStatusTagColor(record.status.label)} />;
          }}
        />
        <FunctionField label='Type' render={(record: Order) => record.action.label} />
        <TextField source='description' label='Security Name' />
        <TextField source='symbol' label='Security Symbol' />
        <FunctionField label='Order Type' render={(record: Order) => record.type.label} />
        <TextField source='quantity' label='Number of Share(s)' />
        <TextField source='filledQuantity' label='Number of Filled Share(s)' />
        <NumberField source='price' label='Price per Share' options={{ style: 'currency', currency: 'USD' }} />
        <NumberField source='commission' label='Service Fee' options={{ style: 'currency', currency: 'USD' }} />
        <NumberField source='totalCost' label='Total Amount' options={{ style: 'currency', currency: 'USD' }} />
        <DateField source='updatedAt' label='Date' />
        <FunctionField label='TB State' render={(record: Order) => record.status.eventLabel} />
      </Datagrid>
    </List>
  );
};
